<div class="screen-container">
  <div class="screen splash1" [class.active]="currentScreen === 'splash1'" [class.inactive]="currentScreen !== 'splash1'">

    <img src="assets/images/honeycomb-pattern.svg" alt="Honeycomb Background" class="honeycomb-bg position-absolute d-none top-0 start-0">
    <!-- Side Images -->
    <img src="../assets/images/Group1.png" alt="" class="side-images d-none d-sm-block position-absolute top-0 start-0">
    <img src="../assets/images/Group2.png" alt="" class="side-images d-none d-sm-block position-absolute bottom-0 end-0">

    <div class="logo-container">
      <img src="assets/images/PeriscopeLogo.png" class="logo" alt="Visitor Bridge">
    </div>
    <div class="powered-by d-flex flex-column text-center z-2">
      <small class="text-black mb-2">Powered By</small>
      <img src="assets/images/dnvLogo.png" alt="Powered by DNV Group" class="dnv-group-logo-1">
    </div>
  </div>

  <div class="screen screen1 splash2" [class.active]="currentScreen === 'splash2'" [class.inactive]="currentScreen !== 'splash2'">

    <img src="assets/images/honeycomb-pattern.svg" alt="Honeycomb Background" class="honeycomb-bg position-absolute d-none top-0 start-0">
    <!-- Side Images -->
    <img src="../assets/images/Group1.png" alt="" class="side-images d-none d-sm-block position-absolute top-0 start-0">
    <img src="../assets/images/Group2.png" alt="" class="side-images d-none d-sm-block position-absolute bottom-0 end-0">

    <img src="assets/images/PeriscopeLogo.png" class="logo-centered logo-zoom" alt="Visitor Bridge">

    <div class="powered-by-1 d-flex flex-column text-center z-2">
      <small class="text-black mb-2">Powered By</small>
      <img src="assets/images/dnvLogo.png" alt="Powered by DNV Group" class="dnv-group-logo-1">
    </div>
  </div>

  <div class="screen screen1 login" [class.active]="currentScreen === 'login'" [class.inactive]="currentScreen !== 'login'" [class.covered]="shutterAnimating">
  
    <!-- Honeycomb Pattern Background Image -->
    <img src="assets/images/honeycomb-pattern.svg" alt="Honeycomb Background" class="honeycomb-bg position-absolute d-none top-0 start-0">
    <img src="assets/images/PeriscopeLogo.png" class="login-logo" alt="Visitor Bridge">
    <img src="assets/images/Periscope-Graphic.png" alt="Visual" class="login-illustration img-fluid visual-img">
    <!-- <img src="assets/images/Office Desk.svg" class="login-illustration" alt="Office Desk"> -->

    <!-- Side Images -->
    <img src="../assets/images/Group1.png" alt="" class="side-images d-none d-sm-block position-absolute top-0 start-0">
    <img src="../assets/images/Group2.png" alt="" class="side-images d-none d-sm-block position-absolute bottom-0 end-0">

    <a class="btn primary" routerLink="/login">Login</a>
    <a class="btn secondary" routerLink="/register">Register</a>


    <div class="text-center mt-2 powered-by-2">
      <small>Powered By</small>
      <img src="assets/images/dnvLogo.png" alt="DNV Group Logo" class="img-fluid dnv-mobile-logo">
    </div>

    <div class="footer-links">
      <!-- <a href="#" class="custom-anchor">Terms of service</a> |  -->
      <a href="#" class="custom-anchor" data-bs-toggle="modal" data-bs-target="#privacyModal" (click)="openPrivacyModal()">Privacy policy</a>
      <!-- <a href="#" class="custom-anchor">Support</a> -->
    </div>
    <div class="position-fixed bottom-0 w-100">
      <div class="row g-0">
        <div class="col-4 one-grid"></div>
        <div class="col-4 two-grid"></div>
        <div class="col-4 three-grid"></div>
      </div>
    </div>

    <!-- Privacy Policy Modal -->
  <div *ngIf="showPrivacyPolicy" class="main-modal" id="privacyModal" aria-labelledby="privacyModalLabel" aria-hidden="true">
    <div class="modal-main-content rounded-4 p-4">
      <div class="modal-header">
        <h5 class="modal-title fw-bold me-auto" id="privacyModalLabel">Privacy Policy</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closePrivacyModal()"></button>
      </div>

      <div class="modal-body pt-3 justify-text">
        <p>
          <strong>VisitorBridge</strong> is the brandname of Visitor Management Solution provided by <strong>DNV
            Security Solutions Pvt Ltd</strong>.
          DNV Security Solutions Pvt Ltd (referred to as “DNV”, “we”, “our”, or “us”) values the privacy of all users of
          the VisitorBridge platform —
          including host organizations, their employees, and visitors. This Privacy Policy outlines how we collect, use,
          and safeguard information based on user type.
        </p>
  
        <hr>
  
        <h6 class="fw-bold">1. Privacy Policy for Host Organizations and Their Employees</h6>
        <p>
          This section applies to organizations that use VisitorBridge to manage visitor entry and their assigned
          employees (Admins, Super Admins, Hosts).
        </p>
        <p class="fw-bold mb-1">Information We Collect:</p>
        <ul>
          <li>Organization Name</li>
          <li>Employee Names, Email IDs, Phone Numbers</li>
          <li>Role-based access information (e.g., Host, Admin)</li>
          <li>Audit trails and log activity</li>
          <li>Usage preferences and configuration settings</li>
        </ul>
        <p class="fw-bold mb-1">How We Use This Information:</p>
        <ul>
          <li>To create and manage organization accounts</li>
          <li>To assign appropriate user roles</li>
          <li>To facilitate visitor approval workflows</li>
          <li>To provide support and implementation services</li>
          <li>To monitor system usage and enhance security</li>
        </ul>
        <p class="fw-bold mb-1">Data Security & Access:</p>
        <ul>
          <li>Only authorized users from your organization can access your data</li>
          <li>DNV does not use host data for advertising or marketing</li>
          <li>Data access is role-based and logged for auditability</li>
        </ul>
        <p class="fw-bold mb-1">Data Storage:</p>
        <ul>
          <li>Hosted securely on cloud infrastructure within India or other compliant jurisdictions</li>
        </ul>
  
        <hr>
  
        <h6 class="fw-bold">2. Privacy Policy for Visitors</h6>
        <p>This section applies to individuals who are visiting an organization using the VisitorBridge platform.</p>
        <p class="fw-bold mb-1">Information We Collect:</p>
        <ul>
          <li>Full Name</li>
          <li>Contact Number</li>
          <li>Email Address</li>
          <li>Government ID details (e.g., Aadhaar, PAN, Driving License)</li>
          <li>Host Name and Department</li>
          <li>Purpose and duration of visit</li>
          <li>Declaration consent (if required)</li>
          <li>Safety video acknowledgment (if required)</li>
        </ul>
        <p class="fw-bold mb-1">How We Use This Information:</p>
        <ul>
          <li>To authenticate and register your visit</li>
          <li>To notify your host</li>
          <li>To ensure security and compliance of the visited workplace</li>
          <li>To facilitate faster entry in future visits (if marked as favourite)</li>
        </ul>
        <p class="fw-bold mb-1">Data Handling:</p>
        <ul>
          <li>The information is collected on behalf of the host organization</li>
          <li>Data is only accessible to authorized users within that organization</li>
          <li>Visitor data is not shared with third parties for advertising or profiling</li>
        </ul>
        <p class="fw-bold mb-1">Data Retention & Security:</p>
        <ul>
          <li>Visitor data is encrypted in transit and at rest</li>
          <li>Access is restricted to approved roles (e.g., Admin, Super Admin)</li>
          <li>Blacklisted visitors will be flagged and blocked as per organization policy</li>
        </ul>
  
        <hr>
  
        <h6 class="fw-bold">3. General Terms for All Users</h6>
        <p class="fw-bold mb-1">Data Hosting & Transfers:</p>
        <ul>
          <li>Data is hosted on secure, third-party cloud infrastructure within India or other permitted regions</li>
        </ul>
        <p class="fw-bold mb-1">Policy Updates:</p>
        <ul>
          <li>This policy may be revised periodically. The updated version will be available on our website and app
            login page with the effective date.</li>
        </ul>
        <div class="text-center">
          <p class="fw-bold mb-1">Contact Us:</p>
          <ul>
            <li>Email: <a href="mailto:support&#64;visitorbridge.in">support&#64;visitorbridge.in</a></li>
            <li>Email: <a href="mailto:contact&#64;dnvsspl.com">contact&#64;dnvsspl.com</a></li>
          </ul>
        </div>       
      </div>
  
    </div>
  </div>
    
    <!-- Shutter overlay inside login screen -->
    <div class="reveal-shutter" [class.animate-reveal]="shutterAnimating"></div>
  </div>
</div>